/** @format */

import React from "react";
import { useTranslation } from "react-i18next";
import { difficultyLevel } from "../resources/types";

import "./LevelBanners.scss";

type Props = {
  levels?: difficultyLevel[];
};

const LevelBanners: React.FC<Props> = ({ levels }) => {
  const { t: _ } = useTranslation();

  return (
    <div className="level-banners d-flex flex-wrap flex-row justify-content-end d-lg-block text-end flex-shrink-0">
      {levels &&
        levels.map(
          (level: "foundation" | "intermediate" | "higher", index: number) => {
            let label = "";
            switch (level) {
              case "foundation":
                label = _("Foundation tier");
                break;
              case "intermediate":
                label = _("Intermediate tier");
                break;
              case "higher":
                label = _("Higher tier");
                break;
            }
            return (
              <div
                key={index}
                className={`level-banner-item level-${level} px-3 py-1 mb-2`}
                title={label}
              >
                <p className="m-0">{label}</p>
              </div>
            );
          },
        )}
    </div>
  );
};

export default LevelBanners;
